// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"384":"088ab43c","584":"a724f826"}[chunkId] + ".chunk.css";
};